import React, { Component } from "react";
import { Link } from "react-router-dom";
import UserAvatar from "react-user-avatar";

import * as ROUTES from "../../constants/routes";

import "./Navigation.css";
import { withFirebase } from "../Firebase";
import { AuthUserContext } from "../Session";

const Navigation = () => (
  <AuthUserContext.Consumer>
    {(authUser) => (authUser ? <NavigationAuth /> : <NavigationNonAuth />)}
  </AuthUserContext.Consumer>
);

const NavigationNonAuth = () => (
  <div className="nav-bar">
    <Link to={ROUTES.LANDING}>Timeline</Link>
    <Link to={ROUTES.SIGN_IN}>Sign In</Link>
    <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
  </div>
);

class NavigationAuthBase extends Component {
  state = {
    username: "",
  };

  componentDidMount() {
    this.setState({ loading: true });

    var uid = this.props.firebase.auth.currentUser.uid;

    this.props.firebase.users().on("value", (snapshot) => {
      const usersObject = snapshot.val();
      const username = usersObject[uid].username;
      this.setState({
        username: username,
      });
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  render() {
    return (
      <div className="nav-bar">
        <Link to={ROUTES.HOME}>Timelines</Link>
        <Link to={ROUTES.ACCOUNT}>
          <div className="account">
            <h3>{this.state.username}</h3>
            {this.state.username ? (
              <UserAvatar size="40" name={this.state.username} />
            ) : null}
          </div>
        </Link>
      </div>
    );
  }
}

const NavigationAuth = withFirebase(NavigationAuthBase);

export default Navigation;
